import { CEFR_LABELS } from "../lib/cefr";

// Swiss CEFR badge: square, mono. Learner's level = signal fill; `muted` for reference scales.
export default function CefrBadge({ level, size = "md", showLabel = false, muted = false, testId }) {
  const sizeCls = {
    sm: "text-xs px-2.5 py-1 gap-2",
    md: "text-sm px-3 py-1.5 gap-2",
    lg: "text-base px-4 py-2 gap-2.5",
    xl: "text-lg px-5 py-2.5 gap-3",
  }[size];
  const tone = muted
    ? "border border-foreground/30 text-muted-foreground bg-transparent"
    : "border border-signal bg-signal text-ink";

  return (
    <span data-testid={testId} className={`inline-flex items-center font-mono-fig font-bold ${tone} ${sizeCls}`}>
      <span className="tracking-wider">{level}</span>
      {showLabel && <span className="font-sans font-medium opacity-80">— {CEFR_LABELS[level]}</span>}
    </span>
  );
}
